import {Space} from "antd";
import {SubSettingsPurchaseLimitCheckboxFormField} from "./purchase-limit-checkbox-form-field";
import {SubSettingsPurchaseLimitValueFormField} from "./purchase-limit-value-form-field";

/** The one wording every offering's Settings step uses for this cap. */
export const PURCHASE_LIMIT_LABEL =
  "Set the number of units a customer can purchase in a single transaction";

export function SubSettingsPurchaseLimitFormField({label}: {label: string}) {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <SubSettingsPurchaseLimitCheckboxFormField label={label} />
        <SubSettingsPurchaseLimitValueFormField />
      </Space>
    </div>
  );
}
